import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import PropTypes from "prop-types";
import _ from "lodash";
import { toast } from "react-toastify";
import Spinner from "components/common/Spinner";
import EditCellModal from "components/menu/master-files/planogram-maintenance/edit-cell-modal";
import CellTypes from "components/menu/master-files/planogram-maintenance/cell-types";
import {
    getPlanogramById,
    getPlanogramLayoutList,
    createPlanogramLayout
} from "api/menu/master-files/planogram-maintenance/actions";
import {
    openCustomModal,
    closeCustomModal
} from "components/custom/modals";

class PlanogramLayout extends React.Component {
    positioning = {
        startRow: false,
        startColumn: false,
        endRow: false,
        endColumn: false
    };

    moveStarted = false;

    constructor(props) {
        super(props);

        this.state = {
            planogramSingle: this.props.planogramSingle,
            planogramLayoutList: this.props.planogramLayoutList,
            pageNumber: 1
        };

        this.createTable = this.createTable.bind(this);
        this.resetMarking = this.resetMarking.bind(this);
        this.startMarking = this.startMarking.bind(this);
        this.moveMarking = this.moveMarking.bind(this);
        this.endMarking = this.endMarking.bind(this);
        this.handleEditCell = this.handleEditCell.bind(this);
        this.handleEditDataCell = this.handleEditDataCell.bind(this);
        this.handleChangeCell = this.handleChangeCell.bind(this);
        this.handleMerge = this.handleMerge.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleRemoveTextAreas = this.handleRemoveTextAreas.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);

        this.props.getPlanogramById(this.props.planogramId);
        document.addEventListener("click", this.handleRemoveTextAreas, false);
    }

    componentDidMount() {
        this.props.getPlanogramLayoutList(this.props.planogramId);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            planogramSingle: nextProps.planogramSingle,
            planogramLayoutList: nextProps.planogramLayoutList
        });
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleRemoveTextAreas);
    }

    handleRemoveTextAreas = (ev) => {
        const target = ev.target;
        if (target.tagName !== "TEXTAREA") {
            const table = document.getElementById("layout-table");
            if (table !== null) {
                const thArray = table.getElementsByTagName("th");
                const tdArray = table.getElementsByTagName("td");
                // eslint-disable-next-line no-empty,no-restricted-syntax
                for (const cell of thArray) {
                    const childrenNodes = cell.childNodes;
                    childrenNodes.forEach(element => {
                        if (element.tagName === "SPAN") {
                            element.classList.remove("d-none");
                        } else if (element.tagName === "TEXTAREA") {
                            element.classList.add("d-none");
                        }
                    });
                }
                // eslint-disable-next-line no-empty,no-restricted-syntax
                for (const cell of tdArray) {
                    const childrenNodes = cell.childNodes;
                    childrenNodes.forEach(element => {
                        if (element.tagName === "SPAN") {
                            element.classList.remove("d-none");
                        } else if (element.tagName === "TEXTAREA") {
                            element.classList.add("d-none");
                        }
                    });
                }
            }
        }
    };

    handleEditCell = (ev, cell) => {
        const element = document.querySelector(`[data-column="${cell.column}"][data-row="${cell.row}"]`);
        if (element !== null) {
            // console.error("zzz", element.getAttribute("data-celltype"));
            const span = element.getElementsByTagName("span");
            if (span.length && span[0]) {
                span[0].classList.add("d-none");
            }
            const textarea = element.getElementsByTagName("textarea");
            if (textarea.length && textarea[0]) {
                textarea[0].classList.remove("d-none");
                textarea[0].focus();
            }
        }
    };

    handleEditDataCell = (ev, cell) => {
        const element = document.querySelector(`[data-column="${cell.column}"][data-row="${cell.row}"]`);
        if (element !== null) {
            const cellData = { ...cell };
            if (!cellData.planogramId) {
                cellData.planogramId = this.props.planogramId;
            }
            const modalObj = {
                modalSettings: {
                    size: "sm",
                },
                header: `${cell.planogramLayoutId ? "Edit" : "New"} Cell`,
                children: (
                    <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                        <EditCellModal
                            cell={cellData}
                            onCancel={() => this.props.closeCustomModal(modalObj)}
                            onSave={(newCell) => {
                                this.handleSaveDataCell(newCell);
                                this.props.closeCustomModal(modalObj);
                            }}
                        />
                    </React.Suspense>
                ),
                handleClose: () => this.props.closeCustomModal(modalObj)
            };
            this.props.openCustomModal(modalObj);
        }
    };

    handleSaveDataCell = (cell) => {
        const { planogramLayoutList } = this.state;

        if (cell.planogramLayoutId) {
            const index = planogramLayoutList
            .findIndex(item => item.planogramLayoutId === cell.planogramLayoutId);
            if (index < 0) {
                return;
            }

            planogramLayoutList[index] = cell;
        } else {
            planogramLayoutList.push(cell);
        }

        this.setState({ planogramLayoutList });
    };

    handleChangeCell = (ev, cell) => {
        const { planogramLayoutList } = this.state;
        const index = planogramLayoutList
            .findIndex(item => item.planogramLayoutId === cell.planogramLayoutId);
        if (index < 0) {
            return;
        }
        const value = ev.target.value;
        const element = document.querySelector(`[data-column="${cell.column}"][data-row="${cell.row}"]`);
        if (element !== null) {
            const span = element.getElementsByTagName("span");
            if (span.length && span[0]) {
                span[0].innerHTML = value;
            }
        }
        planogramLayoutList[index].caption = value;
    };

    handleMerge = () => {
        const { planogramLayoutList } = this.state;
        console.error("handleMerge", this.positioning);

        const startRow = this.positioning.startRow > this.positioning.endRow
            ? this.positioning.endRow
            : this.positioning.startRow;
        const endRow = this.positioning.endRow > this.positioning.startRow
            ? this.positioning.endRow
            : this.positioning.startRow;
        const startColumn = this.positioning.startColumn > this.positioning.endColumn
            ? this.positioning.endColumn
            : this.positioning.startColumn;
        const endColumn = this.positioning.endColumn > this.positioning.startColumn
            ? this.positioning.endColumn
            : this.positioning.startColumn;

        const selectedItems = [];
        planogramLayoutList.forEach(item => {
            if (item.row >= startRow
                && item.row < endRow
                && item.column >= startColumn
                && item.column < endColumn) {
                    const index = selectedItems.findIndex(i =>
                        i.row === item.row && i.column === item.column);
                    if (index === -1) {
                        selectedItems.push(item);
                    } else {
                        selectedItems[index] = item;
                    }
            }
        });

        let mergeImpossible = false;
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const index in selectedItems) {
            if (selectedItems[index].rowSpan > 1 || selectedItems[index].columnSpan > 1) {
                mergeImpossible = true;
                break;
            }
        }
        if (mergeImpossible) {
            toast("Merge impossible. There is already merged cells.", {
                type: toast.TYPE.WARNING,
            });
            return;
        }

        let firstItem = false;
        selectedItems.forEach(item => {
            if (firstItem === false) {
                firstItem = item;
            } else if (item.row < firstItem.row || item.column < firstItem.column) {
                firstItem = item;
            }
        });

        if (firstItem) {
            const newFirstItem = {
                ...firstItem,
                columnSpan: endColumn - startColumn,
                rowSpan: endRow - startRow
            };
            const index = planogramLayoutList.findIndex(item =>
                item.planogramLayoutId === newFirstItem.planogramLayoutId);
            const tmp = [...planogramLayoutList];
            tmp[index] = newFirstItem;
            this.setState({
                planogramLayoutList: tmp
            });
        }
    };

    handleSeparate = () => {
        const { planogramLayoutList } = this.state;

        const startRow = this.positioning.startRow > this.positioning.endRow
            ? this.positioning.endRow
            : this.positioning.startRow;
        const endRow = this.positioning.endRow > this.positioning.startRow
            ? this.positioning.endRow
            : this.positioning.startRow;
        const startColumn = this.positioning.startColumn > this.positioning.endColumn
            ? this.positioning.endColumn
            : this.positioning.startColumn;
        const endColumn = this.positioning.endColumn > this.positioning.startColumn
            ? this.positioning.endColumn
            : this.positioning.startColumn;

        const selectedItems = [];
        planogramLayoutList.forEach(item => {
            if (item.row >= startRow
                && item.row < endRow
                && item.column >= startColumn
                && item.column < endColumn) {
                    const index = selectedItems.findIndex(i =>
                        i.row === item.row && i.column === item.column);
                    if (index === -1) {
                        selectedItems.push(item);
                    } else {
                        selectedItems[index] = item;
                    }
            }
        });

        if (selectedItems.length) {
            if (selectedItems[0].rowSpan > 1 || selectedItems[0].columnSpan > 1) {
                const newFirstItem = {
                    ...selectedItems[0],
                    columnSpan: 1,
                    rowSpan: 1
                };

                const index = planogramLayoutList.findIndex(item =>
                    item.planogramLayoutId === selectedItems[0].planogramLayoutId);
                const tmp = [...planogramLayoutList];
                tmp[index] = newFirstItem;
                this.setState({
                    planogramLayoutList: tmp
                });
            } else  {
                toast("Split impossible. The cells were not merged.", {
                    type: toast.TYPE.WARNING,
                });
            }
        } else {
            toast("Split impossible. No cell were not selected.", {
                type: toast.TYPE.WARNING,
            });
        }
    };

    handleSave = () => {
        this.props.createPlanogramLayout(
            this.props.planogramId,
            this.state.planogramLayoutList
        );
    };

    createTable = () => {
        const { planogramLayoutList, planogramSingle } = this.state;
        const {
            numberOfHeaderRows,
            numberOfColumns,
            numberOfRows,
            // dataRowsCount,
            // layoutCellsCount
        } = planogramSingle;
        const { planogramDataList } = this.props;
        const textAreaStyles = { backgroundColor: "transparent", border: "none", outline: "none" };

        const layouts = {},
            forRemove = {};
        planogramLayoutList.forEach(layout => {
            if (!layouts[layout.row]) {
                layouts[layout.row] = {};
            }
            layouts[layout.row][layout.column] = layout;

            if (!forRemove[layout.row]) {
                forRemove[layout.row] = {};
            }
            if (layout.columnSpan > 1) {
                _.range(
                    layout.column + 1,
                    layout.column + 2 * (layout.columnSpan - 1)
                ).forEach(removeColumn => {
                    if (!forRemove[layout.row][removeColumn]) {
                        forRemove[layout.row][removeColumn] = true;
                    }
                });
            }
            if (layout.rowSpan > 1) {
                _.range(
                    layout.row + 1,
                    layout.row + layout.rowSpan
                ).forEach(removeRow => {
                    if (!forRemove[removeRow]) {
                        forRemove[removeRow] = {};
                    }
                    if (!forRemove[removeRow][layout.column]) {
                        forRemove[removeRow][layout.column] = true;
                    }

                    if (layout.columnSpan > 1) {
                        _.range(
                            layout.column + 1,
                            layout.column + 2 * (layout.columnSpan - 1)
                        ).forEach(removeColumn => {
                            if (!forRemove[removeRow][removeColumn]) {
                                forRemove[removeRow][removeColumn] = true;
                            }
                        });
                    }
                });
            }
        });

        // const { layouts, forRemove } = this.state;
        const thead = [],
            tbody = [];
        _.range(
            0,
            numberOfHeaderRows + 1
        ).map(row => (
            thead.push(<tr key={`header-${row}`}>
                {_.range(0, numberOfColumns + 1).map(column => {
                    if (forRemove[row] && forRemove[row][column]) {
                        return (
                            <th
                                className="d-none"
                                key={`${row}-${column}`}
                                data-column={column}
                                data-row={row}
                            />
                        );
                    }
                    if (row === 0) {
                        return (
                            <th
                                className="text-nowrap g-pointer-events-none"
                                key={`${row}-${column}`}
                                data-column={column}
                                data-row={row}
                            >{column === 0 ? "" : `Column ${column}`}</th>
                        );
                    } else if (column === 0) {
                        return (
                            <th
                                className="text-nowrap"
                                key={`${row}-${column}`}
                                data-column={column}
                                data-row={row}
                            >{row === 0 ? "" : `Header ${row}`}</th>
                        );
                    }

                    const currentCell = layouts[row] && layouts[row][column]
                        ? layouts[row][column]
                        : {
                            row,
                            column,
                            rowSpan: 1,
                            columnSpan: 1
                        };
                    const rowSpan = currentCell ? currentCell.rowSpan : 1;
                    const colSpan = currentCell ? currentCell.columnSpan : 1;
                    return (
                        <th
                            key={`${row}-${column}`}
                            rowSpan={rowSpan}
                            colSpan={colSpan}
                            data-id={currentCell ? currentCell.planogramLayoutId : ""}
                            data-column={column}
                            data-row={row}
                            data-celltype={currentCell.cellType}
                            onMouseDown={(ev) => this.startMarking(ev, currentCell)}
                            onMouseMove={(ev) => this.moveMarking(ev, currentCell)}
                            onMouseUp={(ev) => this.endMarking(ev, currentCell)}
                            onDoubleClick={currentCell.cellType !== CellTypes.DataCell
                                ? (ev) => this.handleEditCell(ev, currentCell)
                                : null
                            }
                        >
                            <span>{currentCell ? currentCell.caption : ""}</span>
                            {currentCell.cellType === CellTypes.DataCell ||
                                <textarea
                                    className="d-none"
                                    style={textAreaStyles}
                                    defaultValue={currentCell ? currentCell.caption : ""}
                                    onChange={(ev) => this.handleChangeCell(ev, currentCell)}
                                />
                            }
                        </th>
                    );
                })}
            </tr>)
        ));
        _.range(
            numberOfHeaderRows + 1,
            numberOfRows + numberOfHeaderRows + 1
        ).map(row => (
            tbody.push(<tr key={`data-${row}`}>
                {_.range(0, numberOfColumns + 1).map(column => {
                    if (forRemove[row] && forRemove[row][column]) {
                        return (
                            <td
                                className="d-none"
                                key={`${row}-${column}`}
                                data-column={column}
                                data-row={row}
                            />
                        );
                    }
                    if (column === 0) {
                        return (

                            <td
                                className="text-nowrap g-pointer-events-none"
                                key={`${row}-${column}`}
                                data-column={column}
                                data-row={row}
                            >Row {((this.state.pageNumber - 1) * this.state.planogramSingle.numberOfRows + row) - numberOfHeaderRows}</td>

                        );
                    }

                    const currentCell = layouts[row] && layouts[row][column]
                        ? layouts[row][column]
                        : {
                            row,
                            column,
                            rowSpan: 1,
                            columnSpan: 1
                        };
                    const rowSpan = currentCell ? currentCell.rowSpan : 1;
                    const colSpan = currentCell ? currentCell.columnSpan : 1;
                    const slotDataIndex = planogramDataList.findIndex(el =>
                        el.planogramDataId === currentCell.planogramDataId);
                    const content = (
                        <React.Fragment>
                            {currentCell.caption ? currentCell.caption : ""} <br />
                            {slotDataIndex >= 0 ? `Slot: ${planogramDataList[slotDataIndex].slotCode}` : ""} <br />
                            {currentCell.quantity ? `QTY: ${currentCell.quantity}` : ""} <br />
                        </React.Fragment>
                    );
                    return (
                        <td
                            key={`${row}-${column}`}
                            rowSpan={rowSpan}
                            colSpan={colSpan}
                            data-id={currentCell ? currentCell.planogramLayoutId : ""}
                            data-column={column}
                            data-row={row}
                            data-celltype={currentCell.cellType}
                            onMouseDown={(ev) => this.startMarking(ev, currentCell)}
                            onMouseMove={(ev) => this.moveMarking(ev, currentCell)}
                            onMouseUp={(ev) => this.endMarking(ev, currentCell)}
                            onDoubleClick={currentCell.cellType === CellTypes.Header ||
                                currentCell.cellType === CellTypes.ReadOnly
                                    ? (ev) => this.handleEditCell(ev, currentCell)
                                    : (ev) => this.handleEditDataCell(ev, currentCell)
                            }
                            style={currentCell.cellType === CellTypes.ReadOnly
                                ? { backgroundColor: "#faebd7" }
                                : null}
                        >
                            <span>{currentCell ? content : ""}</span>
                            {currentCell.cellType === CellTypes.DataCell ||
                            <textarea
                                className="d-none"
                                style={textAreaStyles}
                                defaultValue={currentCell ? currentCell.caption : ""}
                                onChange={(ev) => this.handleChangeCell(ev, currentCell)}
                            />
                            }
                        </td>
                    );
                })}
            </tr>)
        ));

        return {
            thead,
            tbody
        };
    };

    resetMarking = () => {
        this.positioning = {
            startRow: false,
            startColumn: false,
            endRow: false,
            endColumn: false
        };
        this.moveStarted = false;
        this.resetSelected();
    };

    resetSelected = () => {
        // const thElements = document.getElementsByTagName("th");
        // const tdElements = document.getElementsByTagName("td");
        // // eslint-disable-next-line no-plusplus
        // for (let i = 0; i < thElements.length; i++) {
        //     thElements[i].classList.remove("planogram-table-selected");
        // }
        // // eslint-disable-next-line no-plusplus
        // for (let i = 0; i < tdElements.length; i++) {
        //     tdElements[i].classList.remove("planogram-table-selected");
        // }

        const thElements = document.querySelectorAll("th.planogram-table-selected");
        const tdElements = document.querySelectorAll("td.planogram-table-selected");
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < thElements.length; i++) {
            thElements[i].classList.remove("planogram-table-selected");
        }
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tdElements.length; i++) {
            tdElements[i].classList.remove("planogram-table-selected");
        }
    };

    startMarking = (ev, item) => {
        this.resetMarking();

        this.moveStarted = true;
        this.positioning.startRow = item.row;
        this.positioning.startColumn = item.column;
        this.positioning.endRow = item.row + item.rowSpan;
        this.positioning.endColumn = item.column + item.columnSpan;

        this.setBackground(item);
    };

    moveMarking = (ev, item) => {
        if (this.moveStarted) {
            this.setBackground(item);
        }
    };

    endMarking = (ev, item) => {
        if (this.moveStarted) {
            this.moveStarted = false;
            this.setBackground(item);
        }
    };

    setBackground = (item) => {
        const allPositions = Object.keys(this.positioning)
            .filter(position => this.positioning[position] !== false).length;
        if (!allPositions) {
            return;
        }

        this.resetSelected();
        const prevPositions = { ...this.positioning };

        if (this.positioning.startRow > this.positioning.endRow) {
            this.positioning.endRow = item.row;
        } else if (this.positioning.startRow === this.positioning.endRow) {
            this.positioning.endRow = item.row - item.rowSpan;
        } else {
            this.positioning.endRow = item.row + item.rowSpan;
        }

        if (this.positioning.startColumn > this.positioning.endColumn) {
            this.positioning.endColumn = item.column;
        } else {
            this.positioning.endColumn = item.column + item.columnSpan;
        }

        if (prevPositions.endColumn > this.positioning.endColumn) {
            if (this.positioning.startColumn === this.positioning.endColumn) {
               this.positioning.endColumn = item.column - item.columnSpan;
            }
        }

        const startRow = this.positioning.startRow > this.positioning.endRow
            ? this.positioning.endRow
            : this.positioning.startRow;
        const endRow = this.positioning.endRow > this.positioning.startRow
            ? this.positioning.endRow
            : this.positioning.startRow;
        const startColumn = this.positioning.startColumn > this.positioning.endColumn
            ? this.positioning.endColumn
            : this.positioning.startColumn;
        const endColumn = this.positioning.endColumn > this.positioning.startColumn
            ? this.positioning.endColumn
            : this.positioning.startColumn;

        // eslint-disable-next-line no-plusplus
        for (let row = startRow; (row < endRow); row++) {
            // eslint-disable-next-line no-plusplus
            for (let column = startColumn; column < endColumn; column++) {
                const elem = document.querySelectorAll(`[data-row="${row}"][data-column="${column}"]`);
                if (elem) {
                    elem.forEach((item, index) => {
                        elem[index].classList.add("planogram-table-selected");
                    });
                }
            }
        }
    };

    handlePageClick(page) {
        this.setState({
            pageNumber: page.selected + 1
        }, () => {
            this.props.getPlanogramLayoutList(this.props.planogramId, page.selected)
        });
    }

    render() {
        const { loading } = this.props;
        const {
            planogramSingle,
            planogramLayoutList
        } = this.state;
        if (
            !planogramSingle
            || !Object.keys(planogramSingle).length
            || !planogramLayoutList.length
        ) {
            return null;
        }
        const tableStructure = this.createTable();
        // console.error("planogramSingle", planogramSingle);
        // console.error("planogramLayoutList", planogramLayoutList);
        // console.error(planogramLayoutList.filter(item =>
        //     item.row === 2 && item.column === 1));

        // console.error(planogramLayoutList.filter(item =>
        //     item.caption === "JFE01187BK"));

        return (
            <div className="dashboard position-relative">
                {!loading || <Spinner />}

                <div className="d-flex justify-content-between text-right mt-2 mb-2">
                    <div className="d-inline-flex">
                        <button
                            className="btn btn-primary mr-2"
                            onClick={this.handleMerge}
                        >
                            Merge
                        </button>
                        <button
                            className="btn btn-warning"
                            onClick={this.handleSeparate}
                        >
                            Separate
                        </button>
                    </div>
                    <div className="d-inline-flex">
                        <button
                            className="btn btn-success"
                            onClick={this.handleSave}
                        >
                            Save
                        </button>
                    </div>
                </div>

                <table id="layout-table" className="table table-bordered mb-4 text-center user-select-none">
                    <thead>
                    {tableStructure.thead}
                    </thead>
                    <tbody>
                    {tableStructure.tbody}
                    </tbody>
                </table>
                <div className="container">
                    <ReactPaginate
                        nextLabel="next >"
                        onPageChange={this.handlePageClick}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={2}
                        pageCount={this.props.planogramLayoutTotal / this.state.planogramSingle.numberOfRows}
                        previousLabel="< previous"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                        renderOnZeroPageCount={null}
                    />
                </div>
            </div>
        );
    }
}

PlanogramLayout.propTypes = {
    planogramId: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
    loading: state.planogramMaintenance.loading,
    planogramSingle: state.planogramMaintenance.planogramSingle,
    planogramLayoutList: state.planogramMaintenance.planogramLayoutList,
    planogramLayoutTotal: state.planogramMaintenance.planogramLayoutTotal,
    planogramDataList: state.planogramMaintenance.planogramDataList,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getPlanogramById: bindActionCreators(getPlanogramById, dispatch),
    getPlanogramLayoutList: bindActionCreators(getPlanogramLayoutList, dispatch),
    createPlanogramLayout: bindActionCreators(createPlanogramLayout, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(PlanogramLayout);
